export default __webpack_public_path__ + "static/SupremeLL-Regular-f6e120ba04ef98d2253d75623165a277.woff2";